/**
 * Subscription cart gift — reads config from `#subscription-gift-root` (Liquid).
 * Eligible when cart has a line with selling_plan_allocation (not customer tags).
 * Coexists with inveterate subscriber gift (`_inveterate_subscriber_gift`).
 */
(function () {
  function readBool(el, key) {
    return el.dataset[key] === 'true';
  }

  var root = document.getElementById('subscription-gift-root');
  if (!root) return;

  var vidRaw = (root.dataset.variantId || '').trim();
  var VARIANT_ID = vidRaw ? Number(vidRaw) : NaN;
  var COOKIE_NAME = root.dataset.cookieName || 'subscription_gift';
  var SUPPRESSED = root.dataset.cookieSuppressedValue || 'suppressed';
  var PROP_KEY = root.dataset.propertyKey || '_subscription_gift';
  var ENABLED_GIFT_SETTING = readBool(root, 'enabled');
  var GIFT_READY = readBool(root, 'giftReady');
  var lastVariantQty = null;
  var skipRemovalDetect = false;
  var skipAutoAddUntilInteraction = false;
  var reconcileTimer = null;
  /** Aborts stale `cart.js` GET when a newer `reconcile` run starts (read coalescing). */
  var reconcileCartReadAbort = null;

  var giftLineLoadingRef = 0;
  var giftSlotAddingRef = 0;
  /** System clamp/remove: dim row without flipping Remove → "Removing…". */
  var giftLineLoadingShowRemoveBusy = false;
  var addInFlight = false;
  var CART_UPDATED_WAIT_MS = 12000;

  var fetchJsonHeaders = {
    Accept: 'application/json',
    'X-Requested-With': 'xmlhttprequest',
  };

  var postJsonHeaders = {
    'Content-Type': 'application/json',
    'X-Requested-With': 'xmlhttprequest',
  };

  /** Full cart.js / cart/update.js payload (not cart/add.js partial `items`). */
  function isFullCartPayload(data) {
    return !!(data && Array.isArray(data.items) && data.token != null && typeof data.item_count === 'number');
  }

  /** @param {AbortSignal} [signal] */
  function fetchCartJson(signal) {
    var init = { headers: fetchJsonHeaders };
    if (signal) init.signal = signal;
    return fetch(window.Shopify.routes.root + 'cart.js', init).then(function (r) {
      return r.json();
    });
  }

  function postCartJson(url, body) {
    return fetch(window.Shopify.routes.root + url, {
      method: 'POST',
      headers: postJsonHeaders,
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json();
    });
  }

  /**
   * @param {boolean} show
   * @param {{ showRemoveBusy?: boolean }} [opts]
   */
  function applyGiftLinesLoading(show, opts) {
    var showRemoveBusy = !!(opts && opts.showRemoveBusy);
    document.querySelectorAll('[data-subscription-gift]').forEach(function (row) {
      if (row.classList.contains('cart__drawer-item')) row.classList.toggle('cart__drawer-item--loading', show);
      if (row.classList.contains('cart-table__item')) row.classList.toggle('cart-table__item--loading', show);
      if (show) row.setAttribute('aria-busy', 'true');
      else row.removeAttribute('aria-busy');

      var btn = row.querySelector('[data-subscription-gift-remove]');
      if (btn) {
        btn.disabled = show;
        var idle = btn.querySelector('[data-subscription-gift-remove-idle]');
        var busy = btn.querySelector('[data-subscription-gift-remove-busy]');
        if (idle && busy) {
          if (show && showRemoveBusy) {
            idle.classList.add('hidden');
            busy.classList.remove('hidden');
          } else {
            idle.classList.remove('hidden');
            busy.classList.add('hidden');
          }
        }
      }
    });
  }

  /** @param {{ showRemoveBusy?: boolean }} [opts] */
  function beginGiftLineMutation(opts) {
    giftLineLoadingRef++;
    if (opts && opts.showRemoveBusy) giftLineLoadingShowRemoveBusy = true;
    if (giftLineLoadingRef === 1) {
      applyGiftLinesLoading(true, { showRemoveBusy: giftLineLoadingShowRemoveBusy });
    }
  }

  function endGiftLineMutation() {
    if (giftLineLoadingRef <= 0) return;
    giftLineLoadingRef--;
    if (giftLineLoadingRef === 0) {
      applyGiftLinesLoading(false, { showRemoveBusy: false });
      giftLineLoadingShowRemoveBusy = false;
    }
  }

  function applyGiftSlotAdding(show) {
    var slot = document.getElementById('subscription-gift-slot');
    if (!slot) return;
    var btn = slot.querySelector('[data-subscription-add-gift]');
    if (!btn) return;
    btn.disabled = show;
    var idle = btn.querySelector('[data-subscription-slot-idle]');
    var busy = btn.querySelector('[data-subscription-slot-busy]');
    if (idle && busy) {
      idle.classList.toggle('hidden', show);
      busy.classList.toggle('hidden', !show);
    }
  }

  function beginSlotAdding() {
    giftSlotAddingRef++;
    if (giftSlotAddingRef === 1) applyGiftSlotAdding(true);
  }

  function endSlotAdding() {
    if (giftSlotAddingRef <= 0) return;
    giftSlotAddingRef--;
    if (giftSlotAddingRef === 0) applyGiftSlotAdding(false);
  }

  function attachGiftLineMutationEndGuards() {
    var ended = false;
    function finish() {
      if (ended) return;
      ended = true;
      window.removeEventListener('cart:updated', onCartUpdated);
      clearTimeout(timer);
      endGiftLineMutation();
    }
    function onCartUpdated() {
      finish();
    }
    var timer = setTimeout(finish, CART_UPDATED_WAIT_MS);
    window.addEventListener('cart:updated', onCartUpdated);
  }

  function waitForCartUpdatedOrTimeout(ms) {
    ms = ms || CART_UPDATED_WAIT_MS;
    return new Promise(function (resolve) {
      function done() {
        window.removeEventListener('cart:updated', done);
        clearTimeout(tid);
        resolve();
      }
      window.addEventListener('cart:updated', done);
      var tid = setTimeout(done, ms);
    });
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setSuppressedCookie() {
    var maxAgeDays = 180;
    var attrs = [
      COOKIE_NAME + '=' + encodeURIComponent(SUPPRESSED),
      'path=/',
      'SameSite=Lax',
      'Max-Age=' + maxAgeDays * 24 * 60 * 60,
    ];
    if (location.protocol === 'https:') attrs.push('Secure');
    document.cookie = attrs.join('; ');
  }

  function deleteCookie(name) {
    document.cookie = name + '=; path=/; Max-Age=0; SameSite=Lax';
  }

  /** Feature + gift product ready (cart-based subscription eligibility checked separately). */
  function featureEligible() {
    return ENABLED_GIFT_SETTING && GIFT_READY && vidRaw !== '' && !Number.isNaN(VARIANT_ID);
  }

  function clearSuppressCookieIfFeatureIneligible() {
    if (!featureEligible()) deleteCookie(COOKIE_NAME);
  }

  function isSuppressed() {
    return getCookie(COOKIE_NAME) === SUPPRESSED;
  }

  function cartLineHasGiftMark(item) {
    if (!item) return false;
    var props = item.properties;
    if (props == null) return false;
    if (Array.isArray(props)) {
      for (var ia = 0; ia < props.length; ia++) {
        var p = props[ia];
        var k = p && (p.name != null ? String(p.name) : p.first != null ? String(p.first) : '');
        var v = p && (p.value != null ? p.value : p.last);
        if (k === PROP_KEY && v != null && String(v) !== '') return true;
      }
      return false;
    }
    if (typeof props !== 'object') return false;
    var val = props[PROP_KEY];
    return val != null && String(val) !== '';
  }

  function lineHasSellingPlan(item) {
    if (!item || cartLineHasGiftMark(item)) return false;
    var sp = item.selling_plan_allocation;
    if (sp != null && typeof sp === 'object') {
      if (sp.selling_plan != null) return true;
      if (Object.keys(sp).length > 0) return true;
    }
    // Some payloads expose selling plan only as an id on the line.
    if (item.selling_plan != null && item.selling_plan !== 0 && item.selling_plan !== '') return true;
    return false;
  }

  /**
   * One pass over cart lines — variant qty for configured gift SKU, managed-line flag,
   * subscription presence, and “every line is this gift-marked”.
   */
  function analyzeCartGiftState(cart) {
    var empty = {
      variantQty: 0,
      hasManagedLine: false,
      onlyManagedGiftLines: false,
      hasSubscriptionLine: false,
    };
    if (!cart || !cart.items || !cart.items.length) return empty;

    var items = cart.items;
    var variantQty = 0;
    var hasManagedLine = false;
    var onlyManagedGiftLines = true;
    var hasSubscriptionLine = false;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var isGift = cartLineHasGiftMark(item);
      if (isGift) hasManagedLine = true;
      else onlyManagedGiftLines = false;
      if (lineHasSellingPlan(item)) hasSubscriptionLine = true;
      if (vidRaw !== '' && String(item.variant_id) === vidRaw) {
        variantQty += Number(item.quantity) || 0;
      }
    }
    return {
      variantQty: variantQty,
      hasManagedLine: hasManagedLine,
      onlyManagedGiftLines: onlyManagedGiftLines,
      hasSubscriptionLine: hasSubscriptionLine,
    };
  }

  function variantQtyInCart(cart) {
    return analyzeCartGiftState(cart).variantQty;
  }

  function resolveCartAfterUpdateResponse(data) {
    if (isFullCartPayload(data)) return Promise.resolve(data);
    return fetchCartJson();
  }

  function syncSlotConcealClass(slot, hasManagedLine) {
    if (!slot) return;
    if (hasManagedLine) slot.classList.add('hidden');
  }

  function updateUiVisibility(snapshotCart) {
    if (!featureEligible()) return;
    var slot = document.getElementById('subscription-gift-slot');
    if (!slot) return;

    function hideSlot() {
      slot.classList.add('hidden');
    }
    function showSlot() {
      slot.classList.remove('hidden');
    }

    function applyFromCart(cart) {
      var s = analyzeCartGiftState(cart);
      syncSlotConcealClass(slot, s.hasManagedLine);
      var sup = isSuppressed();
      var present = s.hasManagedLine || (vidRaw !== '' && s.variantQty > 0);
      var eligible = s.hasSubscriptionLine;
      if (sup && !present && eligible) showSlot();
      else hideSlot();
    }

    if (snapshotCart && snapshotCart.items) {
      applyFromCart(snapshotCart);
      return;
    }

    fetchCartJson()
      .then(applyFromCart)
      .catch(function () {
        hideSlot();
      });
  }

  function clampVariantToOne(cart) {
    var total = variantQtyInCart(cart);
    if (total <= 1 || Number.isNaN(VARIANT_ID)) return Promise.resolve(cart);

    var lines = cart.items.filter(function (item) {
      return String(item.variant_id) === vidRaw;
    });
    if (!lines.length) return Promise.resolve(cart);

    lines.sort(function (a, b) {
      var aGift = cartLineHasGiftMark(a) ? 1 : 0;
      var bGift = cartLineHasGiftMark(b) ? 1 : 0;
      return bGift - aGift;
    });

    var keepKey = lines[0].key;
    var updates = {};
    cart.items.forEach(function (item) {
      if (String(item.variant_id) === vidRaw) {
        updates[item.key] = item.key === keepKey ? 1 : 0;
      }
    });

    beginGiftLineMutation({ showRemoveBusy: false });
    skipRemovalDetect = true;
    return postCartJson('cart/update.js', { updates: updates, sections: 'cart-drawer,cart-main' })
      .then(function (data) {
        if (window.updateCartContents) window.updateCartContents(data);
        if (window.refreshCart) window.refreshCart();
        return resolveCartAfterUpdateResponse(data).then(function (fresh) {
          return waitForCartUpdatedOrTimeout().then(function () {
            return fresh;
          });
        });
      })
      .finally(function () {
        endGiftLineMutation();
        skipRemovalDetect = false;
      });
  }

  function removeManagedGiftLines(cart, skipSectionsRefresh) {
    if (!cart || !cart.items) return Promise.resolve();
    var updates = {};
    cart.items.forEach(function (it) {
      if (cartLineHasGiftMark(it)) updates[it.key] = 0;
    });
    if (Object.keys(updates).length === 0) return Promise.resolve();

    beginGiftLineMutation({ showRemoveBusy: false });
    skipRemovalDetect = true;
    var body = { updates: updates };
    if (!skipSectionsRefresh) body.sections = 'cart-drawer,cart-main';
    return postCartJson('cart/update.js', body)
      .then(function (data) {
        if (!skipSectionsRefresh && window.updateCartContents) window.updateCartContents(data);
        if (!skipSectionsRefresh && window.refreshCart) window.refreshCart();
        if (!skipSectionsRefresh) {
          return waitForCartUpdatedOrTimeout().then(function () {
            return data;
          });
        }
        return data;
      })
      .finally(function () {
        endGiftLineMutation();
        skipRemovalDetect = false;
      });
  }

  function addGiftLine() {
    if (Number.isNaN(VARIANT_ID) || addInFlight) return Promise.resolve();
    addInFlight = true;
    beginSlotAdding();
    skipRemovalDetect = true;
    if (typeof window.setCheckoutButtonLoading === 'function') window.setCheckoutButtonLoading();
    var props = {};
    props[PROP_KEY] = '1';
    return postCartJson('cart/add.js', {
      items: [{ id: VARIANT_ID, quantity: 1, properties: props }],
      sections: 'cart-drawer,cart-main',
    })
      .then(function (data) {
        var errored = !!(data.status && Number(data.status) >= 400) || !!(data.errors && Object.keys(data.errors).length);
        if (data.description && !data.sections) {
          console.warn('Subscription gift add:', data.description);
          errored = true;
        }
        if (errored) skipAutoAddUntilInteraction = true;
        if (!errored && window.updateCartContents) window.updateCartContents(data);
        if (!errored && window.refreshCart) window.refreshCart();
        if (!errored) {
          return waitForCartUpdatedOrTimeout().then(function () {
            return data;
          });
        }

        return data;
      })
      .finally(function () {
        addInFlight = false;
        endSlotAdding();
        skipRemovalDetect = false;
        if (typeof window.resetCheckoutButtonUi === 'function') window.resetCheckoutButtonUi();
      });
  }

  window.subscriptionGiftSuppressAndRemove = function (lineKey) {
    beginGiftLineMutation({ showRemoveBusy: true });
    attachGiftLineMutationEndGuards();
    setSuppressedCookie();
    if (typeof window.cartItemUpdate === 'function') window.cartItemUpdate(lineKey, 0);
  };

  var reconcileTail = Promise.resolve();

  function reconcile(_cartHint) {
    reconcileTail = reconcileTail
      .then(function () {
        // Always read cart.js for mutate decisions. Event payloads can lag an in-flight
        // add or look like a partial `items`-only response and falsely trigger gift removal.
        if (typeof AbortController !== 'undefined') {
          if (reconcileCartReadAbort) reconcileCartReadAbort.abort();
          reconcileCartReadAbort = new AbortController();
        }
        var readSignal = reconcileCartReadAbort && reconcileCartReadAbort.signal;

        return fetchCartJson(readSignal).then(
          function (payload) {
            reconcileCartReadAbort = null;
            return payload;
          },
          function (err) {
            reconcileCartReadAbort = null;
            throw err;
          }
        );
      })
      .then(function (cart) {
        if (!isFullCartPayload(cart)) return cart;

        if (!featureEligible()) {
          deleteCookie(COOKIE_NAME);
          skipAutoAddUntilInteraction = false;
          lastVariantQty = null;
          var sIn = analyzeCartGiftState(cart);
          if (sIn.hasManagedLine) {
            return removeManagedGiftLines(cart, false).then(function () {});
          }
          lastVariantQty = sIn.variantQty;
          return cart;
        }

        // Empty cart clears any “paused auto-add” from a failed /cart/add — next session should retry.
        if (Number(cart.item_count) === 0) {
          skipAutoAddUntilInteraction = false;
          lastVariantQty = null;
        }

        var s = analyzeCartGiftState(cart);
        var qty = s.variantQty;

        // Skip orphan-gift cleanup while an add is still finishing (avoids remove→re-add flicker).
        if (addInFlight || giftSlotAddingRef > 0) {
          updateUiVisibility(cart);
          lastVariantQty = qty;
          return cart;
        }

        // Gift alone, or gift without any subscription line left in cart → remove.
        if (s.hasManagedLine && (s.onlyManagedGiftLines || !s.hasSubscriptionLine)) {
          if (typeof window.setCheckoutButtonLoading === 'function') window.setCheckoutButtonLoading();
          return removeManagedGiftLines(cart, false)
            .then(resolveCartAfterUpdateResponse)
            .then(function (fresh) {
              lastVariantQty = analyzeCartGiftState(isFullCartPayload(fresh) ? fresh : cart).variantQty;
              updateUiVisibility(isFullCartPayload(fresh) ? fresh : null);
              return fresh;
            })
            .finally(function () {
              if (typeof window.resetCheckoutButtonUi === 'function') window.resetCheckoutButtonUi();
            });
        }

        updateUiVisibility(cart);

        if (!s.hasSubscriptionLine) {
          lastVariantQty = qty;
          return cart;
        }

        if (isSuppressed()) {
          lastVariantQty = qty;
          if (qty > 1) return clampVariantToOne(cart);
          return cart;
        }

        if (qty > 1) {
          return clampVariantToOne(cart).then(function (c2) {
            lastVariantQty = analyzeCartGiftState(c2 || cart).variantQty;
          });
        }

        // Prefer property mark over bare variant qty so we never double-add while qty is stale.
        if (!s.hasManagedLine && qty === 0 && !skipAutoAddUntilInteraction && !addInFlight && Number(cart.item_count) > 0) {
          return addGiftLine().then(function () {
            return fetchCartJson().then(function (fresh) {
              lastVariantQty = analyzeCartGiftState(fresh).variantQty;
              updateUiVisibility(fresh);
              return fresh;
            });
          });
        }

        lastVariantQty = qty;
        return cart;
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
      });

    return reconcileTail;
  }

  function scheduleReconcile() {
    clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(function () {
      reconcileTimer = null;
      reconcile();
    }, 0);
  }

  function initSubscriptionGiftListeners() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target && ev.target.closest && ev.target.closest('[data-subscription-add-gift]');
      if (!btn || !featureEligible()) return;
      if (!document.getElementById('subscription-gift-slot')) return;
      if (!btn.closest || !btn.closest('#subscription-gift-slot')) return;
      ev.preventDefault();
      deleteCookie(COOKIE_NAME);
      skipAutoAddUntilInteraction = false;
      lastVariantQty = null;
      updateUiVisibility();
      addGiftLine().then(function () {
        var wrap = document.querySelector('.cart__drawer-wrap');
        if (wrap && !wrap.classList.contains('active') && window.showCart) window.showCart();
      });
    });

    window.addEventListener('cart:updated', function (ev) {
      if (giftLineLoadingRef > 0) {
        applyGiftLinesLoading(true, { showRemoveBusy: giftLineLoadingShowRemoveBusy });
      }
      if (giftSlotAddingRef > 0) applyGiftSlotAdding(true);
      var c = ev.detail && ev.detail.cart;
      if (isFullCartPayload(c)) updateUiVisibility(c);
      scheduleReconcile();
    });
    window.addEventListener('cart:added', function () {
      scheduleReconcile();
    });
    window.addEventListener('cart:drawer-opened', function () {
      scheduleReconcile();
    });
  }

  function boot() {
    clearSuppressCookieIfFeatureIneligible();
    initSubscriptionGiftListeners();
    lastVariantQty = null;
    reconcile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
